import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../../routes/routes'
import { RootState } from '../../store'
import confirmService from '../../services/confirm.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import { replacePage, replaceLimit, replaceSearch } from './WorkOrders.slice'
import { paginate, deleteWorkOrder } from './WorkOrders.thunk'
import Button from '../../components/Button'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import DataTable from '../../components/DataTable'
import HeadingRow from '../../components/HeadingRow'
import { ActionName } from '../../components/Actions'
import { TableHorizontalHeader } from '../../components/TableHorizontal'

interface WorkOrdersRouteState {
  id: number
  produceAt?: string
}

interface WorkOrdersProps
  extends RouteComponentProps<any, any, WorkOrdersRouteState>, ConnectedProps<typeof connector> {}

class WorkOrders extends Component<WorkOrdersProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Work order"), path: 'code' },
    { heading: i18n("Line"), path: 'line' },
    { heading: i18n("Item"), path: 'item.code' },
    { heading: i18n("Production"), path: 'quantity.amount' },
    { heading: i18n("Produced"), path: 'quantity.produced' },
    { heading: i18n("Remaining"), path: 'quantity.remaining' },
    { heading: i18n("Adjustment"), path: 'quantity.adjustment' },
    { heading: i18n("Production date"), path: 'produceAt', date: true },
    { heading: i18n("Actions") }
  ]

  constructor (props: WorkOrdersProps) {
    super(props)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleCalendarClick = this.handleCalendarClick.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  handleCalendarClick () {
    this.props.history.push(routes.workOrderCalendar)
  }

  handleCreateClick () {
    this.props.history.push(routes.workOrderCreate)
  }

  handleActionClick (id: number, action: ActionName) {
    const { history } = this.props
    if (action === 'view') {
      const pathname = routes.workOrder
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'edit') {
      const pathname = routes.workOrderEdit
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the work order?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.props.deleteWorkOrder(id)
      }
      confirmService.push(confirm)
    }
  }

  setRouteState () {
    const { state: locState } = this.props.location
    if (locState && locState.produceAt) {
      this.props.replaceSearch(locState.produceAt)
    }
  }

  componentDidMount () {
    this.setRouteState()
    this.props.paginate()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Work Orders")}
              doc='work-orders'>
              <Button
                text={i18n("Calendar")}
                onClick={this.handleCalendarClick} />
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <DataTable
              headers={this.headers}
              data={this.props.data}
              total={this.props.total}
              from={this.props.from}
              to={this.props.to}
              currentPage={this.props.currentPage}
              lastPage={this.props.lastPage}
              limit={String(this.props.limit)}
              search={this.props.search}
              onLimtChange={this.handleLimitChange}
              onSearch={this.handleSearch}
              onPaginate={this.handlePaginate}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.workOrders
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  deleteWorkOrder,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(WorkOrders))
